(function () {

  'use strict';

  /**
   * @name ute-ui
   * @version 0.9.1
   * @namespace ute-ui
   */
  angular.module('ute.ui', [
    'ui.bootstrap',
    'ui.router',
    'tmh.dynamicLocale',
    'angularMoment',
    // 'oc.lazyLoad',
    'ngTable',
    'pascalprecht.translate',
    'ngCookies'
  ]);

})();
